<div class="result-title">
  <label class="title">{{ 'imageRemeasurementEdit.result' | translate }}</label>
  <a class="change-unit" (click)="changeUnit.emit()">{{getChangeUnitLabel()}}</a>
</div>
<div class="select-result-div">
  <div>
    <label class="title">{{ 'imageRemeasurementEdit.number' | translate }}</label>
  </div>
  <div class="select-mode">
    <mat-form-field class="select-result" appearance="fill">

      <mat-select matNativeControl name="mode" [(ngModel)]="selectResult">
        <mat-option class="select-item" [value]="result"
          *ngFor="let result of measurementResults">
          {{getMeasurementResultSelectLabel(result)}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="remove-area" *ngIf="isAddPoints && isEdit">
      <evc-nav-button type="icon" class="remove-buttons"
        [type]="'tertiary'"
        [size]="'sm'"
        [variant]="'semi'"
        [leftIcon]="'trash-can'"
        [title]="'imageRemeasurementEdit.removeTooltip' | translate" (click)="deleteResult(selectResult)">
      </evc-nav-button>
    </div>
  </div>

</div>
<div class="result-value" fxLayout="column" *ngIf="selectResult">
  <div *ngFor="let measurement of selectResult?.measurements" class="resultData">
   <span class="label"> {{ "imageRemeasurementEdit." + measurement.label | translate }}</span>
   <span class="value">{{getFormattedValue(measurement)}}  <span class="unit">{{getUnitLabel(measurement.unit)}}</span></span>
  </div>
</div>
